export const characterColors = {
  Olivia: "#f4c2dd",
  Joel: "#56d699",
  Eric: "#a2aee8",
  Petra: "#ff674c",
  Nate: "#efad43",
  Flor: "#bed5d6",
};

export const fonts = {
  bold: '"Maison Neue Bold", sans-serif',
  book: '"Maison Neue Book", sans-serif',
  demi: '"Maison Neue Demi", sans-serif',
  light: '"Maison Neue Light", sans-serif',
  medium: '"Maison Neue Medium", sans-serif',
  mono: '"Maison Neue Mono", sans-serif',
};

export const colors = {
  white: "#fff",
  borderGray: "rgba(255,255,255,0.24)",
  gray: "#a3a3a3",
  darkGray: "#7a7a7a",
  modalGray: "#1a191a",
  modalBorderGray: "#3d3d3d",
  black: "#000",
  moonLight: "rgba(0,0,0,0.24)",
  red: "#ff4848",
  primary: "#17c5ca",
};

export const animations = {
  map: {
    // quad ease-in-out
    easing: "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
    // easing: "ease-in-out",
    // easing: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    // easing: "cubic-bezier(1, 0, 0, 1)",
    duration: 0.5,
  },
  newMap: {
    easing: "linear",
    duration: 5,
  },
};

export const cards = {
  heights: [50, 220, 480],
  widths: [0.2, 0.2, 0.9],
  spacing: [50, 100, 60],
  topOffset: 150,
  totalRows: 8,
};

export const breakpoints = ["480px", "768px"];

export const maxWidths = ["1024px", "1680px"];

export default {
  characterColors,
  fonts,
  colors,
  animations,
  breakpoints,
  maxWidths,
};



// WEBPACK FOOTER //
// ./src/components/theme.js